export default __webpack_public_path__ + "static/media/mickey.1d650af3.gif";